import liveSession from '@livesession/sdk';

export default function init(config) {
  liveSession.init(config.liveSessionTrackId, null, {
    devMode: !config.sessionRecordingEnabled,
  });
}
